import {
  AbrechenbareMitglieder,
  AktiveAnmeldungen,
  AnwesenheitAuslastung,
  BuchungsAuslastung,
  Kuendigung,
  StandortAuslastung,
} from "../models/admin-dashboard-entities";
import { getAdminAxiosInstance } from "./api-config";

export async function getAbrechenbareMitgliederForCurrentMonth(): Promise<AbrechenbareMitglieder> {
  const axiosInstance = getAdminAxiosInstance();
  const response = await axiosInstance.get("/verein/abrechenbare-mitglieder");
  return response.data;
}

export async function getAktiveAnmeldungenForCurrentMonth(): Promise<AktiveAnmeldungen> {
  const axiosInstance = getAdminAxiosInstance();
  const response = await axiosInstance.get("/verein/aktive-anmeldungen");
  return response.data;
}

export async function getKuendigungenForTwoMonths(): Promise<Kuendigung> {
  const axiosInstance = getAdminAxiosInstance();
  const response = await axiosInstance.get("/verein/kundigung");
  return response.data;
}

export async function getBottomTenAnwesenheit(
  startDate?: Date,
  endDate?: Date,
  idStandort?: number
): Promise<{
  bottomTen: Record<string, AnwesenheitAuslastung>;
  all: Record<string, AnwesenheitAuslastung>;
}> {
  const axiosInstance = getAdminAxiosInstance();
  const params: Record<string, string> = {};
  if (startDate && endDate) {
    params.startDate = startDate.toISOString();
    params.endDate = endDate.toISOString();
  }
  if (idStandort && idStandort !== -1) {
    params.idStandort = idStandort.toString();
  }
  const response = await axiosInstance.get("/verein/bottom-anwesenheit", {
    params,
  });
  return { bottomTen: response.data.bottomTen, all: response.data.all };
}

export async function getBottomTenAuslastung(idOrt?: number): Promise<{
  bottomTen: Record<string, BuchungsAuslastung>;
  all: Record<string, BuchungsAuslastung>;
}> {
  const axiosInstance = getAdminAxiosInstance();
  const params: Record<string, string> = {};
  if (idOrt && idOrt !== -1) {
    params.idOrt = idOrt.toString();
  }
  const response = await axiosInstance.get("/verein/bottom-auslastung", {
    params,
  });
  return { bottomTen: response.data.bottomTen, all: response.data.all };
}

export async function getAnwesenheitAuslastung(
  startDate?: Date,
  endDate?: Date
): Promise<AnwesenheitAuslastung> {
  const axiosInstance = getAdminAxiosInstance();
  const params: Record<string, string> = {};
  if (startDate && endDate) {
    params.startDate = startDate.toISOString();
    params.endDate = endDate.toISOString();
  }
  const response = await axiosInstance.get("/verein/anwesenheit-auslastung", {
    params,
  });
  return response.data;
}

export async function getBuchungsAuslastung(): Promise<BuchungsAuslastung> {
  const axiosInstance = getAdminAxiosInstance();
  const response = await axiosInstance.get("/verein/buchungs-auslastung");
  return response.data;
}

export async function getHistorischeWerte(): Promise<{
  abrechenbareMitglieder: number[];
  anwesenheiten: number[];
  buchungen: number[];
  kundigungen: number[];
  neueintritte: number[];
  gruppeVerlassen: number[];
  sportgruppeHinzufugen: number[];
}> {
  const axiosInstance = getAdminAxiosInstance();
  const response = await axiosInstance.get("/verein/dashboard-data");
  return response.data;
}

export async function getStandortAuslastung(): Promise<StandortAuslastung> {
  const axiosInstance = getAdminAxiosInstance();
  const response = await axiosInstance.get("/verein/standort-auslastung");
  return response.data;
}

export async function getMahnwesenDashboardValues(): Promise<{
  import: number;
  expired: number;
}> {
  const axiosInstance = getAdminAxiosInstance();
  const response = await axiosInstance.get("/mahnwesen/dashboard");
  return response.data;
}

export async function getMahngebuhrenDashboard(): Promise<
  Record<string, number>
> {
  const axiosInstance = getAdminAxiosInstance();
  const response = await axiosInstance.get("/mahnwesen/dashboard-mahngebuhren");
  return response.data;
}

export async function getEintritteAustritteData(): Promise<{
  kundigungen: number[];
  neueintritte: number[];
  gruppeVerlassen: number[];
  sportgruppeHinzufugen: number[];
  labels: string[];
}> {
  const axiosInstance = getAdminAxiosInstance();
  const response = await axiosInstance.get("/verein/dashboard-eintritte-austritte");
  return response.data;
}